import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { Box, Typography, List, ListItem } from '@mui/material'
import { Link } from 'react-router-dom'
import Profil from '../../styles/pages/account/Profil.module.scss'
import { RootState } from '../../store/GlobalStore'
import { clearAuthData } from '../../store/slices/authSlice';
import { useNavigate } from 'react-router-dom'
import user from '../../shared/images/Groupe 3449.svg'
import bike from '../../shared/images/Icon material-directions-bike.svg'
import bed from '../../shared/images/Icon awesome-bed.svg'
import star from '../../shared/images/Icon awesome-star.svg'
import megaphone from '../../shared/images/Icon ionic-md-megaphone.svg'
import arrow from '../../shared/images/arrow-down.svg'
import bell from '../../shared/images/Icon awesome-bell.svg'
import key from '../../shared/images/Icon awesome-key.svg'
import alert from '../../shared/images/Icon ionic-ios-alert.svg'
import eye from '../../shared/images/Icon awesome-eye.svg'
import enter from '../../shared/images/door-open-solid.svg'
import exit from '../../shared/images/door-closed-solid.svg'
import NotificationContainer from '../../components/layout/NotificationContainer'
import { useTranslation } from 'react-i18next';
import { useGetMyReservationsQuery } from '../../services/ReservationAPI';
import checkIcon from '../../shared/images/icon check.svg';

const ProfilPage: React.FC = () => {
    const authState = useSelector((state: RootState) => state.Auth);
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const { data: reservations, isLoading } = useGetMyReservationsQuery();
    const today = new Date().toISOString();

    const activeReservations = (reservations as any[])?.filter((res: any) => res.endDate >= today) || [];

    const isCheckInDone = activeReservations.length > 0 && activeReservations.some((res: any) => {
     
        const directCheckIn = res.checkIn || res.check_in;

        const bookingCheckIn = res.Bookings?.some((b: any) => 
            b.checkIn !== null && b.checkIn !== undefined && String(b.checkIn) !== "null"
        );

        return !!directCheckIn || !!bookingCheckIn;
    });

    const isCheckOutDone = activeReservations.length > 0 && activeReservations.every((res: any) => {
        const checkOutInBooking = res.Bookings?.some((b: any) => b.checkOut !== null && String(b.checkOut) !== "null");
        const hasCheckOutRelation = res.check_out !== null && res.check_out !== undefined;

        return checkOutInBooking || hasCheckOutRelation;
    });


    const handleLogout = () => {
        dispatch(clearAuthData());
      };

      const handleNavigation = (path: string) => {
        navigate(path);
    };
    
    console.log("Mes réservations reçues :", reservations);
    return (
        <>
        <div className={Profil.ProfilContainer}> 
            <NotificationContainer />
            <div className={Profil.UserSummary}>
                <div className={Profil.Avatar}>
                {authState.user?.firstname
                    ? (authState.user.firstname.substring(0, 1).toUpperCase() ?? '') +
                    (authState.user.lastname?.substring(0, 1).toUpperCase() ?? '')
                    : (authState.user?.lastname?.substring(0, 2).toUpperCase() ?? '')
                }
                </div>

                <h4 className={Profil.Welcome}>
                    {t('welcome')} {authState.user?.firstname}{' '}
                    {authState.user?.lastname} !
                </h4>
                <button
                    className={Profil.Disconnect}
                    onClick={handleLogout}>
                    {t('logout')}
                </button>

            </div>
            
            <div className={Profil.DesktopFormField}>
                <Box className={Profil.AccountBox}>
                    <Typography className={Profil.AccountTitle}>
                    {t('my_account')}
                    </Typography>
                    <List>
                        <ListItem
                            className={Profil.Button}
                            component={Link}
                            to='/mon-informations'>
                            <div className={Profil.Subtitle}>
                                <img
                                    src={user}
                                    alt='user'
                                    className={Profil.AccountIcon}
                                />
                                <div>{t('personal_info')}</div>
                            </div>
                            <img src={arrow} alt='arrow' />
                        </ListItem>
                        {/*<ListItem
                            className={Profil.MiddleButton}
                            component={Link}
                            to='/mon-compte'>
                            <div className={Profil.Subtitle}>
                                <img
                                    src={key}
                                    alt='key'
                                    className={Profil.AccountIcon}
                                />
                                <div>Mon mot de passe</div>
                            </div>
                            <img src={arrow} alt='arrow' />
                        </ListItem>*/}
                        {/*<ListItem
                            className={Profil.Button}
                            component={Link}
                            to='/notifications'>
                            <div className={Profil.Subtitle}>
                                <img
                                    src={bell}
                                    alt='bell'
                                    className={Profil.AccountIcon}
                                />
                                <div>Notifications</div>
                            </div>
                            <img src={arrow} alt='arrow' />
                        </ListItem>
                        <ListItem
                            className={Profil.Button}
                            component={Link}
                            to='/mon-compte'>
                            <div className={Profil.Subtitle}>
                                <img
                                    src={percentage}
                                    alt='percentage'
                                    className={Profil.AccountIcon}
                                />
                                <div>Mes avantages</div>
                            </div>
                            <img src={arrow} alt='arrow' />
                        </ListItem>*/}
                    </List>
                </Box>
                
                <Box className={Profil.AccountBox}>
                    <Typography className={Profil.AccountTitle}>
                    {t('my_resa')}
                    </Typography>
                    <List>
                        <ListItem
                            className={Profil.Button}
                            component={Link}
                            to='/all-reservations'>
                            <div className={Profil.Subtitle}>
                                <img
                                    src={bed}
                                    alt='bed'
                                    className={Profil.AccountIcon}
                                />
                                <div>{t('housing')}</div>
                            </div>
                            <img src={arrow} alt='arrow' />
                        </ListItem>
                        <ListItem
                            className={Profil.MiddleButton}
                            component={Link}
                            to='/animations'>
                            <div className={Profil.Subtitle}>
                                <img
                                    src={bike}
                                    alt='bike'
                                    className={Profil.AccountIcon}
                                />
                                <div>{t('all_animations')}</div>
                            </div>
                            <img src={arrow} alt='arrow' />
                        </ListItem>
                        <ListItem
                            className={Profil.Button}
                            component={Link}
                            to='/my-animations'>
                            <div className={Profil.Subtitle}>
                                <img
                                    src={megaphone}
                                    alt='megaphone'
                                    className={Profil.AccountIcon}
                                />
                                <div>{t('my_animations')}</div>
                            </div>
                            <img src={arrow} alt='arrow' />
                        </ListItem>
                    </List>
                </Box>
                <Box className={Profil.AccountBox}>
                    <Typography className={Profil.AccountTitle}>ETATS DES LIEUX</Typography>
                    <List>
                        <ListItem
                            className={Profil.SimpleButton}
                            component={Link}
                            to='/check-in'>
                            <div className={Profil.Subtitle}>
                                <img
                                    src={enter}
                                    alt='checkin'
                                    className={Profil.Icon}
                                />
                                <div>{t('CheckInHome')}</div>

                                {isCheckInDone ? (
                                    <img src={checkIcon} alt="Terminé" className={Profil.CheckIcon} />
                                ) : (
                                    <span className={Profil.Cartouche}>{t('To_Do')}</span>
                                )}

                            </div>
                            <img src={arrow} alt='arrow' />
                        </ListItem>
                        <ListItem
                            className={Profil.Button}
                            component={Link}
                            to='/check-out'>
                            <div className={Profil.Subtitle}>
                                <img
                                    src={exit}
                                    alt='checkout'
                                    className={Profil.Icon}
                                />
                                <div>{t('CheckOutHome')}</div>

                                {isCheckOutDone ? (
                                    <img src={checkIcon} alt="Terminé" className={Profil.CheckIcon} />
                                ) : (
                                    <span className={Profil.Cartouche}>{t('To_Do')}</span>
                                )}
                                
                            </div>
                            <img src={arrow} alt='arrow' />
                        </ListItem>
                    </List>
                </Box>
                
               {/* <Box className={Profil.LocationBox}>
                    <List>
                        <ListItem
                            className={Profil.LocationTitle}
                            component={Link}
                            to='/mon-compte'>
                            MES RECOMMANDATIONS
                            <img src={arrow} alt='arrow' />
                        </ListItem>
                    </List>
                </Box>*/}
            </div>
            <div className={Profil.DesktopFormFieldTwo}>
                <Box className={Profil.AccountBox}>
                    <Typography className={Profil.AccountTitle}>
                    {t('ask_and_incidents')}
                    </Typography>
                    <List>
                        <ListItem
                            className={Profil.SimpleButton}
                            component={Link}
                            to='/create-incidient'>
                            <div className={Profil.Subtitle}>
                                <img
                                    src={alert}
                                    alt='alert'
                                    className={Profil.AccountIcon}
                                />
                                <div>{t('create_incident')}</div>
                            </div>
                            <img src={arrow} alt='arrow' />
                        </ListItem>
                        <ListItem
                            className={Profil.Button}
                            component={Link}
                            to='/follow-incidents'>
                            <div className={Profil.Subtitle}>
                                <img
                                    src={eye}
                                    alt='eye'
                                    className={Profil.AccountIcon}
                                />
                                <div>{t('my_follow')}</div>
                            </div>
                            <img src={arrow} alt='arrow' />
                        </ListItem>
                    </List>
                </Box>
            </div>
        </div>
        {/*<div className={Profil.ProfilContainer}>
            <h2>Profil</h2>

            <div className={Profil.MenuContainer}>
                <button onClick={() => handleNavigation('/reservation')}>Ma Réservation</button>
                <button onClick={() => handleNavigation('/activities')}>Mes Activités</button>
                <button onClick={() => handleNavigation('/animations')}>Animations</button>
                <button onClick={() => handleNavigation('/favorites')}>Favoris</button>
            </div>

            <button onClick={handleLogout}>Logout</button>
        </div>*/}
        </>
    )
}

export default ProfilPage
